import dayjs from "dayjs";

export const sortBySortingIndexAndUpdatedAt = (
	a: { sortingIndex: number; updatedAt: string },
	b: { sortingIndex: number; updatedAt: string },
) =>
	a.sortingIndex !== b.sortingIndex
		? a.sortingIndex - b.sortingIndex
		: dayjs(a.updatedAt).unix() - dayjs(b.updatedAt).unix();
